import { motion } from "framer-motion";
import { useState } from "react";
import { FuelMenuNav } from "@/components/fuel-activity/FuelMenuNav";
import { FuelActivityAnalytics } from "@/components/fuel-activity/FuelActivityAnalytics";
import { PageHeader } from "@/components/ui/PageHeader";
import { ExplorerSkeleton } from "@/components/ui/PageSkeleton";
import { defaultFuelActivityFilters } from "@/lib/fuel-analytics";
import { useFuelActivityData } from "@/lib/queries";
import type { FuelActivityFilters } from "@/types/database";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function FuelActivityPage() {
  const { data, isLoading, error } = useFuelActivityData();
  const [filters, setFilters] = useState<FuelActivityFilters>(defaultFuelActivityFilters());

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="space-y-6"
    >
      <PageHeader
        title="User fuel activity"
        description="Review platform-wide consumption and top-ups, compare users, and drill into individual breakdowns with charts and exports."
        showGreeting={false}
      />

      <FuelMenuNav />

      {isLoading ? (
        <ExplorerSkeleton title="User fuel activity" />
      ) : error || !data ? (
        <p className="text-sm text-red-600">Failed to load fuel activity. Please try again.</p>
      ) : (
        <FuelActivityAnalytics
          logs={data.logs}
          users={data.users}
          cars={data.cars}
          stations={data.stations}
          brands={data.brands}
          filters={filters}
          onFiltersChange={setFilters}
        />
      )}
    </motion.div>
  );
}
